//#region REACT
import { useTranslation } from "react-i18next";
import styled from "styled-components";
//#endregion

//#region COMPONENTS
import { NanoFlex } from "../NanoFlex.js";
import Loading from "../Loading.js";
import Type from "../Typography.js";
//#endregion

//#region STYLED COMPONENT
const StyledTable = styled(NanoFlex)`
  .tableWrapper {
    display: table;
    background-color: white;
    padding: 15px;
    table-layout: fixed;
    height: auto;
    border-collapse: collapse;
    .tableRow {
      display: table-row;
      border-bottom: 1px solid #dfe0eb;
      &:last-child {
        border-bottom: 0;
      }
      .tableCell {
        display: table-cell;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        color: #252733;
        padding: 15px;

        .severity {
          width: max-content;
          font-size: 11px;
          line-height: 15px;
          display: flex;
          align-items: center;
          text-align: center;
          letter-spacing: 0.3px;
          text-transform: uppercase;
          color: #ffffff;
          padding: 2px 13px;
        }
      }

      .customPad {
        padding: 0;
      }
    }

    .header {
      font-weight: 600 !important;
      font-size: 13px !important;
      line-height: 18px !important;
      letter-spacing: 0.3px !important;
    }
  }
`;
//#endregion

export default function Table({ data, isLoading }) {
  //TRANSLATION INIT
  const { t } = useTranslation();

  return (
    <StyledTable>
      {data?.length > 0 && !isLoading && (
        <NanoFlex className="tableWrapper">
          <NanoFlex className="tableRow" height="55px">
            <NanoFlex className="tableCell customPad" height="55px">
              <NanoFlex className="tableWrapper">
                <NanoFlex className="tableRow">
                  <NanoFlex className="tableCell header">
                    {t("map.date")}
                  </NanoFlex>
                  <NanoFlex className="tableCell header">
                    {t("map.socialServices")}
                  </NanoFlex>
                  <NanoFlex className="tableCell header">
                    {t("map.status")}
                  </NanoFlex>
                  <NanoFlex className="tableCell header">
                    <NanoFlex justifyContent="flex-end">
                      {t("map.eventSeverity")}
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="tableRow">
            <NanoFlex className="tableCell customPad">
              <NanoFlex height="30vh" overflow="auto" display="block">
                <NanoFlex className="tableWrapper">
                  {data?.map((m, i) => {
                    return (
                      <NanoFlex className="tableRow" key={`${i}_${m}`}>
                        <NanoFlex className="tableCell">{m[0]}</NanoFlex>
                        <NanoFlex className="tableCell">{m[1]}</NanoFlex>
                        <NanoFlex className="tableCell">{m[2]}</NanoFlex>
                        <NanoFlex className="tableCell">
                          <NanoFlex justifyContent="flex-end">
                            <NanoFlex
                              className="severity"
                              radius="50px"
                              color={
                                m[3] === 1
                                  ? "#E53935"
                                  : m[3] === 2
                                  ? "#FF8100"
                                  : "#FFC107"
                              }
                            >
                              {m[3] === 1
                                ? "HIGH"
                                : m[3] === 2
                                ? "MEDIUM"
                                : "LOW"}
                            </NanoFlex>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    );
                  })}
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      )}
      {/* SHOW LOADING WHILE WAITING FOR RESPONSE */}
      {isLoading && <Loading></Loading>}
      {/* SHOW MESSAGE WHEN NO DATA */}
      {data?.length === 0 && !isLoading && (
        <NanoFlex>
          <Type.h2>{t("noResults")}</Type.h2>
        </NanoFlex>
      )}
    </StyledTable>
  );
}
